
namespace Gamification.Gamification {
    export class ProdottiAziendeColumns {
        static columnsKey = 'Gamification.ProdottiAziende';
    }
}